<div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
  <div class="rounded-t border-b-2 mb-0 px-6 py-6">
    <div class="text-center flex justify-between">
      <h6 class="text-primary text-lg font-bold"> حساب کاربری </h6>

    </div>
  </div>
  <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
    <form>
      <h6 class="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
        اطلاعات فردی
      </h6>

      <div class="flex flex-wrap">
        <div class="w-full h-24 px-4 mb-6">
          <div class="flex justify-center">
            <img alt="..." [src]="this.url?this.url:'../../../../assets/img/thumb-profile1.svg.png'"
            onerror="this.onerror=null; this.src='../../../../assets/img/thumb-profile1.svg.png';"
              class="rounded-full h-auto align-middle border-none absolute" width="100px">
            <!-- <div class="w-full lg:w-6/12 p-2 flex justify-center" style="margin-right: 0;">
              <input type="file" id="file" (change)="onSelectFile($event)">
              <label class="btn bg-primary text-white relative mt-16 p-2 rounded-full ms-16 cursor-pointer" for="file">
                <img src="../../../../../assets/img/icon/edit.svg" alt="">
              </label>
            </div> -->
          </div>
        </div>
      </div>

      <div class="flex flex-wrap">

        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              نام
            </label>
            <input type="text" [(ngModel)]="drInfo.name" name="name" disabled
              class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm border-gray-300 w-full" />
          </div>
        </div>
        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              نام خانوادگی
            </label>
            <input type="text" [(ngModel)]="drInfo.family" name="family" disabled
              class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
          </div>
        </div>
        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              جنسیت
            </label>
            <!-- <input type="text" name="gender" disabled [value]="drInfo.gender==0?'آقا':'خانم'"
              class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-60 rounded text-sm w-full" /> -->
            <select disabled [(ngModel)]="drInfo.gender" name="gender" class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-60 rounded text-sm w-full" >
              <option [value]="genderEnum.male"> اقا </option>
              <option [value]="genderEnum.female"> خانم </option>
              <!-- <option [value]="genderEnum.notSet"> مشخص نشده </option> -->
            </select>
          </div>
        </div>
        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              کد ملی
            </label>
            <input type="text" [(ngModel)]="drInfo.meliCode" name="melicode"
              class="border-gray-300 ltr px-3 py-3 placeholder-blueGray-300 text-blueGray-60 rounded text-sm w-full" />
          </div>
        </div>
        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              ایمیل
            </label>
            <input type="email"  [(ngModel)]="drInfo.email" name="email" disabled
              class="border-gray-300 ltr px-3 py-3 placeholder-blueGray-300 text-blueGray-60 rounded text-sm w-full" />
          </div>
        </div>
        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              شماره تماس
            </label>
            <input type="text" [(ngModel)]="drInfo.mobile" name="mobile" disabled
              class="border-gray-300 ltr px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
          </div>
        </div>
        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              سال تولد
            </label>
            <input type="number" [(ngModel)]="drInfo.birthDate" name="birthDate" disabled
              class="border-gray-300 ltr px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
          </div>
        </div>
        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              محل تولد
            </label>
            <input type="text" [(ngModel)]="drInfo.birthDatePlace" name="BirthDatePlace" disabled
              class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
          </div>
        </div>
      </div>

      <hr class="mt-6 border-b-1 border-blueGray-300" />

      <h6 class="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
        اطلاعات تخصصی
      </h6>

      <div class="flex flex-wrap">
        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              تخصص <span class="text-red-700"> * </span>
            </label>
              <select [(ngModel)]="drInfo.medicalEspertiseId" name="medicalEspertiseName" 
                  class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-60 rounded text-sm w-full" >
                    <option *ngFor="let cat of categoriesList" [value]="cat.id"> {{cat.parentName}} - {{cat.name}} </option>
              </select>
          </div>
        </div>
        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              سطح تحصیلات
            </label>
            <input type="text" [(ngModel)]="drInfo.education_s" name="Education_s" disabled
              class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-60 rounded text-sm w-full" />
          </div>
        </div>
        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              شماره نظام پزشکی
            </label>
            <input type="text" [(ngModel)]="drInfo.codeNo" name="codeNo" 
              class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-60 rounded text-sm w-full" />
          </div>
        </div>
        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              تلفن ثابت
            </label>
            <input type="text" [(ngModel)]="drInfo.tel" name="tel" disabled
              class="border-gray-300 ltr px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
          </div>
        </div>
        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              سال شروع فعالیت
            </label>
            <input type="number" [(ngModel)]="drInfo.experience" name="experience" placeholder="1390" maxlength="4" minlength="4" disabled
              class="border-gray-300 ltr px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
          </div>
        </div>
        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              محل فعالیت
            </label>
            <input type="text" [(ngModel)]="drInfo.workPlace" name="WorkPlace" disabled
              class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
          </div>
        </div>

        <div class="w-full lg:w-12/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              آدرس محل کار
            </label>
            <input type="text" [(ngModel)]="drInfo.workAddress" name="workAddress" 
              class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
          </div>
        </div>
        <div class="w-full lg:w-12/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              تجهیزات
            </label>
            <textarea type="text" [(ngModel)]="drInfo.officeEquipment" name="officeEquipment" disabled
              class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full"
              rows="4">  </textarea>
          </div>
        </div>

        <div class="w-full lg:w-12/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              درباره من
            </label>
            <textarea type="text" [(ngModel)]="drInfo.aboutMe" name="aboutMe" disabled
              class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full"
              rows="4">  </textarea>
          </div>
        </div>

        
        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              تسلط به زبان (جهت ویزیت کردن)
            </label>
            <!-- <input type="text" name="keywords" [(ngModel)]="lang"
              class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
              <button class="absolute end-2.5 bottom-2.5 bg-primary text-white hover:cursor-pointer rounded rounded-s-none text-sm p-2 left-0"
              type="submit" style="height: 2.8rem;" (click)="addLangArray()">
                  افزودن   </button> -->
          </div>
        </div>

        <div class="w-full lg:w-6/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              کلمات کلیدی
            </label>
            <!-- <input type="text" [(ngModel)]="keywords" name="keywords"
              class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
              <button class="absolute end-2.5 bottom-2.5 bg-primary text-white hover:cursor-pointer rounded rounded-s-none text-sm p-2 left-0"
              type="submit" style="height: 2.8rem;" (click)="addTagArray()">
                  افزودن   </button> -->
          </div>
        </div>

        <div class="w-full lg:w-6/12">
          <span class="bg-blue-100 text-blue-800 text-sm font-medium inline-flex px-2 py-1 rounded border border-primary m-2" *ngFor="let lang of drInfo.lags"> 
             {{lang}} </span>
        </div>

        <div class="w-full lg:w-6/12">
          <span class="bg-blue-100 text-blue-800 text-sm font-medium inline-flex px-2 py-1 rounded border border-primary m-2" *ngFor="let tag of drInfo.tags"> 
             {{tag}} </span>
        </div>

        <div class="w-full lg:w-6/12 p-2">
          <div class="w-full flex mt-8">
            <input type="checkbox" [(ngModel)]="drInfo.isActiveAttendanceVisit" name="isActiveAttendanceVisit" id="onlie"
              class="border-gray-300 px-3 py-3 rounded" disabled />
            <label for="onlie" class="block text-blueGray-600 text-sm font-bold mx-2">
              قابلیت نسخه نویسی آنلاین
            </label>
          </div>
        </div>
      </div>

      <hr class="mt-6 border-b-1 border-blueGray-300" />

      <h6 class="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
        اطلاعات مالی
      </h6>

      <div class="flex flex-wrap">
        <div class="w-full lg:w-4/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              نام بانک
            </label>
            <input type="text" [(ngModel)]="drInfo.bank" name="bank" disabled
              class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-60 rounded text-sm w-full" />
          </div>
        </div>
        <div class="w-full lg:w-4/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              شماره حساب
            </label>
            <input type="text" [(ngModel)]="drInfo.accountNo" name="accountNo" disabled
              class="border-gray-300 ltr px-3 py-3 placeholder-blueGray-300 text-blueGray-60 rounded text-sm w-full" />
          </div>
        </div>
        <div class="w-full lg:w-4/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              شماره کارت
            </label> 
            <input type="text" [(ngModel)]="drInfo.card" name="card" disabled
              class="border-gray-300 ltr px-3 py-3 placeholder-blueGray-300 text-blueGray-60 rounded text-sm w-full" />
          </div>
        </div>
        <div class="w-full lg:w-8/12 p-2">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              شماره شبا
            </label>
            <input type="text" [(ngModel)]="drInfo.sheba" name="sheba" disabled
              class="border-gray-300 ltr px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
          </div>
        </div>
      </div>

      <div class="w-full lg:w-12/12 p-2">
        <div class="flex justify-end w-full mb-3">
          <button type="button" (click)="updateDoctorInfo()"
            class="bg-primary text-white active:bg-green-900 font-bold uppercase text-lg px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1">
            تایید اطلاعات
          </button>
        </div>
      </div>

    </form>
  </div>
</div>


<p-toast dir="rtl"></p-toast>






<!-- MODAL SECTION -->

<app-modal #modal>
  <!--header-->
  <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
    <h3 class="text-2xl font-semibold">
      تصویر پروفایل
    </h3>
    <button
      class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
      (click)="modal.close()">
      <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
        ×
      </span>
    </button>
  </div>
  <!--body-->
  <div class="relative p-6 flex-auto">
    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1 / 1"
      [onlyScaleDown]="true" [roundCropper]="false" [alignImage]="'center'" [hideResizeSquares]="false"
      [style.display]="showCropper ? null : 'none'" format="png" (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded($event)" (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"
      style="max-width: 550px;max-height: 450px;"></image-cropper>
  </div>
  <!--footer-->
  <div class="flex items-center justify-between p-6 border-t border-solid border-blueGray-200 rounded-b">
    <button
      class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150"
      type="button" (click)="modal.close()">
      انصراف
    </button>
    <button
      class="bg-primary text-white active:bg-red-500 font-bold text-sm px-6 py-2 rounded shadow hover:shadow-lg my-2 ease-linear transition-all duration-150"
      type="button">
      تایید
    </button>
  </div>
</app-modal>